const labelsValidationHR = {
    "name": {
        "required": "Naziv etikete je obavezan",
        "unique": "Ups! Ova etiketa već postoji i u vlasništvu je drugog korisnika. Molimo pokušajte s drugim nazivom etikete. Ako legalno posjedujete ovaj naziv etikete i posjedujete autorska prava na naziv, molimo kontaktirajte naš tim za podršku.",
        "available": "Naziv etikete je dostupan",
        "invalid": "Naziv etikete je nevažeći"
    },
    "year": {
        "required": "Godina osnivanja je obavezna",
        "numeric": "Vrijednost nije broj",
        "stringLength": "Godina osnivanja mora imati 4 znamenke"
    },
    "releaseCatalog": {
        "required": "Izdanja u katalogu su obavezna",
        "numeric": "Vrijednost nije broj"
    },
    "logo": {
        "required": "Logo je obavezan",
        "dimensions": "Veličina logotipa etikete mora biti 1000 x 1000 px, JPG/JPEG/PNG.",
        "choose": "Molimo odaberite sliku",
        "file": "Molimo prenesite JPG ili PNG formate, minimalna rezolucija 1000x1000px. Maksimalna veličina 2MB"
    },
    "promo_graphic": {
        "dimensions": "Veličina promotivne grafike etikete mora biti 960 x 150 px, JPG/JPEG/PNG.",
        "choose": "Molimo odaberite sliku",
        "file": "Prenesite JPG ili PNG formate, minimalna rezolucija 960x150px"
    }
};

export default labelsValidationHR;